import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export default function useClients(orgId: string | null, enabled: boolean = true) {
  const glynt = useGlynt();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['clients', { organization: orgId }],
    queryFn: async () => (await glynt).clientApi.list({ organization: orgId ?? undefined }),
    enabled: !!orgId && enabled,
    refetchOnWindowFocus: false,
  });

  return {
    data: data?.results ?? [],
    isLoading,
    isError,
    refetch,
  };
}
